// Side-effect import, before the router is made: Stripe's secrets leave the address first (stripeReturn.ts).
import { dropStripeReturnSecrets } from './stripeReturn';

dropStripeReturnSecrets();
